import type { OrderType } from '@/shared/types/domain.types';

interface OrderTypeFilterProps {
  selectedOrderType?: OrderType | 'ALL';
  onChange: (orderType?: OrderType | 'ALL') => void;
}

export function OrderTypeFilter({ selectedOrderType, onChange }: OrderTypeFilterProps) {
  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Order Type
      </label>
      <select
        value={selectedOrderType || 'ALL'}
        onChange={(e) => onChange(e.target.value as OrderType | 'ALL')}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="ALL">All Types</option>
        <option value="STOCK">Stock</option>
        <option value="PATIENT">Patient</option>
      </select>
    </div>
  );
}
